import Offer from "../Models/Offer"
import Plan from "../Models/Plan"
import PlanOption from "../Models/PlanOption"
import SuggestionModel from "../Models/SuggestionModel"
import PlaceDetailsModel from "../Models/PlaceDetailsModel"
import PlanRequest from "../Requests/PlanRequest"
import UserRequest from "../Requests/UserRequest"
import Response from "../../../Responses/Response"
import GroupType from "../Types/GroupType"
import Customer from "../Models/Customer"
import CustomerRequest from "../Requests/CustomerRequest"
import UploadDocumentRequest from "../Requests/UploadDocumentRequest"
import ContractStoreRequest from "../Requests/ContractStoreRequest"
import PaymentMode from "../Models/PaymentMode"
import PaymentType from "../Models/PaymentType"
import Media from "../Models/Media"
import ContractStoreResponse from "../Models/ContractStoreResponse"
import PackageProductsResponse from "../Models/PackageProducts"
import PackageProducts from "../Models/PackageProducts"
import PackageProductsRequest from "../Requests/PackageProductsRequest"
import EmailCheckRequest from "../Requests/EmailCheckRequest"
import PecCheckRequest from "../Requests/PecCheckRequest"
import DocumentCheckRequest from "../Requests/DocumentCheckRequest"

class API {
	public static async getCoverageSuggestionsAsync(text?: string): Promise<Response<SuggestionModel[]>> {
		if (process.env.NODE_ENV === "development" && (process.env.REACT_APP_HOST === "" || process.env.REACT_APP_HOST === undefined)) {
			return {
				success: true,
				errors: [],
				data: [
					{ id: "1", name: "Posto1" },
					{ id: "2", name: "Posto2" },
					{ id: "3", name: "Posto3" },
					{ id: "4", name: "Posto4" },
					{ id: "5", name: "Posto5" }
				]
			}
		}
		else {
			let res = await fetch(`${process.env.REACT_APP_HOST}/api/places/${text}`)
			return await res.json()
		}
	}

	public static async getplaceDetailsAsync(placeId?: string): Promise<Response<PlaceDetailsModel>> {

		if (process.env.NODE_ENV === "development" && (process.env.REACT_APP_HOST === "" || process.env.REACT_APP_HOST === undefined)) {
			return {
				success: true,
				errors: [],
				data: { province: "MI", municipality: "Abbiategrasso", cap: "20063", address: "Via Assunta", civicNumber: "3", is_covered: false }
			}
		}
		else {
			let res = await fetch(`${process.env.REACT_APP_HOST}/api/places/details/${placeId}`)
			return await res.json()
		}
	}

	public static async getOffersAsync(customerType: number, isCovered: boolean): Promise<Response<Offer[]>> {
		if (process.env.NODE_ENV === "development" && (process.env.REACT_APP_HOST === "" || process.env.REACT_APP_HOST === undefined)) {
			return {
				success: true,
				errors: [],
				data: [
					{
						id: "1",
						name: "",
						ad_line_1: "",
						ad_line_2: "",
						ad_line_3: "",
						ad_speed: "10",
						ad_title: "",
						ad_subtitle: "al mese",
						background_color: "blu",
						description_color: "",
						connection_type: "",
						package_type: "",
						image_url: "",
						price: 10,
						price_color: "",
						ad_price: "10 €",
						vat_price: 10,
						figurative_price: 10

					}
				]
			}
		}
		else {
			let res = await fetch(`${process.env.REACT_APP_HOST}/api/packages/all`, {
				method: 'POST',
				body: JSON.stringify({
					"customerTypeId": customerType,
					"isCovered": isCovered
				}),
				headers: {
					"Content-type": "application/json; charset=UTF-8",
					"Accept": "application/json"
				}
			})
			return await res.json()
		}
	}

	public static async getPackageProductsAsync(packageId: string): Promise<Response<PackageProducts[]>> {
		let res = await fetch(`${process.env.REACT_APP_HOST}/api/packages/${packageId}/products`, {
			method: 'POST',
			headers: {
				"Content-type": "application/json; charset=UTF-8",
				"Accept": "application/json"
			}
		})
		return await res.json()
	}

	public static async getPlanAsync(packageId: string, request: PlanRequest): Promise<Response<Plan>> {
		if (process.env.NODE_ENV === "development" && (process.env.REACT_APP_HOST === "" || process.env.REACT_APP_HOST === undefined)) {
			return {
				success: true,
				errors: [],
				data: {
					id: "1",
					name: 'Piano Fibra 50',
					details: [],
					periodic_costs: [],
					total_periodic_price: { label: "", value: "0.00 $" },
					una_tantum_costs: [],
					total_una_tantum_price: { label: "", value: "0.00 $" }
				}
			}
		}
		else {
			let res = await fetch(`${process.env.REACT_APP_HOST}/api/packages/${packageId}/plan`, {
				method: 'POST',
				body: JSON.stringify(request),
				headers: {
					"Content-type": "application/json; charset=UTF-8",
					"Accept": "application/json"
				}
			})
			return await res.json()
		}
	}

	public static async postUserAsync(user: UserRequest): Promise<boolean> {
		if (process.env.NODE_ENV === "development" && (process.env.REACT_APP_HOST === "" || process.env.REACT_APP_HOST === undefined)) {
			return true
		}
		else {
			let res = await fetch(`${process.env.REACT_APP_HOST}/api/users/store`, {
				method: 'PUT',
				body: JSON.stringify(user),
				headers: {
					"Content-type": "application/json; charset=UTF-8",
					"Accept": "application/json"
				}
			})

			return res.ok
		}
	}

	public static async getOptionsAsync(packageId: string, request: PackageProductsRequest): Promise<Response<PlanOption[]>> {
		if (process.env.NODE_ENV === "development" && (process.env.REACT_APP_HOST === "" || process.env.REACT_APP_HOST === undefined)) {
			return {
				success: true,
				errors: [],
				data: [
					{
						id: 123,
						name: "IP",
						description: "Scelta opzioni IP",
						group_type: GroupType.mandatoryMultipleChoice,
						is_visible: true,
						default_product_id: null,
						product_category: "Additional and Optional Services",
						products: [
							{
								id: 1,
								name: "IP DINAMICO",
								description: "",
								type: 1,
								price: 19,
								periodic_price: 10,
								periodic_discounted_price: 10,
								una_tantum_discounted_price: 10,
								una_tantum_price: 10,
								formatted_price: "19,00 $"
							},
							{
								id: 2,
								name: "4 IP",
								description: "",
								type: 1,
								price: 12.20,
								periodic_price: 10,
								periodic_discounted_price: 10,
								una_tantum_discounted_price: 10,
								una_tantum_price: 10,
								formatted_price: "12,20 $"
							},
							{
								id: 3,
								name: "8 IP",
								description: "",
								type: 1,
								price: 18.30,
								periodic_price: 10,
								periodic_discounted_price: 10,
								una_tantum_discounted_price: 10,
								una_tantum_price: 10,
								formatted_price: "18,30 $"
							}
						]
					},
					{
						id: 456,
						name: "Router",
						description: "Scelta opzione Router",
						group_type: GroupType.mandatoryMultipleChoice,
						is_visible: false,
						default_product_id: null,
						product_category: "Options",
						products: [
							{
								id: 4,
								name: "ROUTER FIBRA LITE",
								description: "Router WIFI 1-2 stanze 4 porte",
								type: 1,
								price: 0,
								periodic_price: 0,
								periodic_discounted_price: 0,
								una_tantum_discounted_price: 0,
								una_tantum_price: 0,
								formatted_price: "0,00 $"
							}
						]
					}
				]
			}
		}
		else {
			let res = await fetch(`${process.env.REACT_APP_HOST}/api/packages/${packageId}/products`, {
				method: 'POST',
				headers: {
					"Content-type": "application/json; charset=UTF-8",
					"Accept": "application/json"
				},
				body: JSON.stringify(request),
			})
			return await res.json()
		}
	}

	public static async getProvincesAsync(): Promise<Response<string[]>> {
		if (process.env.NODE_ENV === "development" && (process.env.REACT_APP_HOST === "" || process.env.REACT_APP_HOST === undefined)) {
			return {
				success: true,
				errors: [],
				data: [
					"MI",
					"BO",
					"PC"
				]
			}
		}
		else {
			let res = await fetch(`${process.env.REACT_APP_HOST}/api/provinces`)
			return await res.json()
		}
	}

	public static async getMunicipalitiesAsync(province?: string): Promise<Response<string[]>> {
		if (process.env.NODE_ENV === "development" && (process.env.REACT_APP_HOST === "" || process.env.REACT_APP_HOST === undefined)) {
			return {
				success: true,
				errors: [],
				data: [
					"Abbiategrasso",
					"Segrate",
					"Milano"
				]
			}
		}
		else {
			let res = await fetch(`${process.env.REACT_APP_HOST}/api/provinces/${province}/municipalities`)
			return await res.json()
		}
	}

	public static async getCapsAsync(province?: string | undefined, municipality?: string): Promise<Response<string[]>> {
		if (process.env.NODE_ENV === "development" && (process.env.REACT_APP_HOST === "" || process.env.REACT_APP_HOST === undefined)) {
			return {
				success: true,
				errors: [],
				data: [
					"20063"
				]
			}
		}
		else {
			let res = await fetch(`${process.env.REACT_APP_HOST}/api/provinces/${province}/municipalities/${municipality}/caps`)
			return await res.json()
		}
	}

	public static async checkEmailAsync(email: EmailCheckRequest): Promise<Response<boolean>> {
		let res = await fetch(`${process.env.REACT_APP_HOST}/api/customers/email-check`, {
			method: 'POST',
			body: JSON.stringify(email),
			headers: {
				"Content-type": "application/json; charset=UTF-8",
				"Accept": "application/json"
			}
		})
		return res.json()
	}

	public static async checkPecAsync(pec: PecCheckRequest): Promise<Response<boolean>> {
		let res = await fetch(`${process.env.REACT_APP_HOST}/api/customers/pec-check`, {
			method: 'POST',
			body: JSON.stringify(pec),
			headers: {
				"Content-type": "application/json; charset=UTF-8",
				"Accept": "application/json"
			}
		})
		return res.json()
	}

	public static async checkDocumentAsync(request: DocumentCheckRequest): Promise<Response<boolean>> {
		let res = await fetch(`${process.env.REACT_APP_HOST}/api/customers/document-check`, {
			method: 'POST',
			body: JSON.stringify(request),
			headers: {
				"Content-type": "application/json; charset=UTF-8",
				"Accept": "application/json"
			}
		})
		return res.json()
	}

	public static async createCustomerAsync(customer: CustomerRequest): Promise<Response<Customer>> {
		let res = await fetch(`${process.env.REACT_APP_HOST}/api/customers/store`, {
			method: 'PUT',
			body: JSON.stringify(customer),
			headers: {
				"Content-type": "application/json; charset=UTF-8",
				"Accept": "application/json"
			}
		})
		return res.json()
	}

	public static async updateCustomerAsync(customerId: Number, customer: CustomerRequest): Promise<Response<Customer>> {
		let res = await fetch(`${process.env.REACT_APP_HOST}/api/customers/${customerId}/update`, {
			method: 'PATCH',
			body: JSON.stringify(customer),
			headers: {
				"Content-type": "application/json; charset=UTF-8",
				"Accept": "application/json"
			}
		})
		return res.json()
	}

	public static async uploadDocumentAsync(customerId: Number, request: UploadDocumentRequest): Promise<Response<Media>> {
		let res = await fetch(`${process.env.REACT_APP_HOST}/api/customers/${customerId}/media/store`, {
			method: 'POST',
			body: JSON.stringify(request),
			headers: {
				"Content-type": "application/json; charset=UTF-8",
				"Accept": "application/json"
			}
		})
		return res.json()
	}

	public static async createContractAsync(request: ContractStoreRequest): Promise<Response<ContractStoreResponse>> {
		let res = await fetch(`${process.env.REACT_APP_HOST}/api/contracts/store`, {
			method: 'POST',
			body: JSON.stringify(request),
			headers: {
				"Content-type": "application/json; charset=UTF-8",
				"Accept": "application/json"
			}
		})
		return res.json()
	}

	public static async sendContractEmailAsync(contractId: Number, rid: number, voip: number): Promise<Response<ContractStoreResponse>> {
		let res = await fetch(`${process.env.REACT_APP_HOST}/api/contracts/${contractId}/mail/${rid}/${voip}`, {
			method: 'GET',
			headers: {
				"Content-type": "application/json; charset=UTF-8",
				"Accept": "application/json"
			}
		})
		return res.json()
	}

	public static async getPaymentModes(customerTypeId: Number): Promise<Response<PaymentMode[]>> {
		let res = await fetch(`${process.env.REACT_APP_HOST}/api/customer_types/${customerTypeId}/payment_modes/all`, {
			method: 'GET',
			headers: {
				"Content-type": "application/json; charset=UTF-8",
				"Accept": "application/json"
			}
		})
		return res.json()
	}

	public static async getPaymentTypes(customerTypeId: Number, paymentModeId: Number): Promise<Response<PaymentMode[]>> {
		let res = await fetch(`${process.env.REACT_APP_HOST}/api/customer_types/${customerTypeId}/payment_modes/${paymentModeId}/payment_types/all`, {
			method: 'GET',
			headers: {
				"Content-type": "application/json; charset=UTF-8",
				"Accept": "application/json"
			}
		})
		return res.json()
	}
}

export default API
